import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import AOS from 'aos';
import styles from '../ContentCard/ContentCard-tw-styles';
import richTextStyles from '../Richtext/Richtext-tw-styles'
import buttonStyles from '../Button/Button-tw-styles';
import headingStyles from '../Heading/Heading-tw-styles';
import getWidth from '../../../utils/gridWidth';
import { getCdnImage } from '../../../utils/ImageManager';
import { Button } from '../../Generic/Button';
import i18nMessages from '../../../constants/messages/pt-BR';
import DOMPurify from 'isomorphic-dompurify';
import Typography from '../../Generic/Typography';

class HomeBanner extends Component {

  componentDidMount() {
    let element = document.getElementsByClassName(i18nMessages.imageStylesleft);
    element[2]?.setAttribute(i18nMessages.dataaos, i18nMessages.fadeleft);
    const AOS = require('aos');
    this.aos = AOS;
    this.aos.init();
    window.addEventListener(i18nMessages.eventload, AOS.refresh);

    let homebanner = document.getElementsByClassName(i18nMessages.homebanner);
    let upperBound = 100;
    let lowerBound = 95;
    let tickValue = (upperBound - lowerBound) / window.innerHeight;
    let textContainer = document.getElementsByClassName(
      i18nMessages.textWrapper
    )[0];

    document.addEventListener(i18nMessages.scroll, function() {
      let offset = window.pageYOffset;
      let count = upperBound - offset * tickValue;
      let scrollValue = 350;
      if (
        document.body.scrollTop > scrollValue ||
        document.documentElement.scrollTop > scrollValue
      ) {
        homebanner[0].style.width = count + '%';
        textContainer.classList.add(i18nMessages.textScroll);
      } else {
        homebanner[0].style.width = 100 + '%';
        textContainer.classList.remove(i18nMessages.textScroll);
      }
    });
  }
  componentDidUpdate() {
    this.aos.refresh();
  }
  componentWillUnmount() {
    window.removeEventListener(i18nMessages.eventload, AOS.refresh);
  }
  
  render() {
    const { data } = this.props;
    let contentType = data.styles && data.styles.trim();
    if (styles[contentType] === undefined) {
      contentType = i18nMessages.homepagetextleft;
    }
    const widthClass = getWidth(data.componentWidth);
    const backgroundImage = `url(${ 
      data &&
        data.secondaryImage &&
        data.secondaryImage.image &&
        data.secondaryImage.image.url
    })`;
    return (
      <div className={classNames(styles[contentType].mainWrapper, widthClass)}>
        <div className={classNames(styles[contentType].innerWrapper)}>
          <div className={styles.homeBannerImgLeft}>
          <div
              className={classNames(styles[contentType].imageWrapper)}
              style={{ backgroundImage: backgroundImage }}
            >
              {data &&
                data.primaryImageCollection &&
                data.primaryImageCollection?.items?.length > 0 &&
                data.primaryImageCollection?.items?.map((imgData, index) => {
                  return (
                    <img
                      key={index}
                      src={getCdnImage(imgData.image && imgData.image.url)}
                      alt={imgData.altText}
                      className={classNames(
                        styles[contentType].imageStyles,
                        getWidth(imgData.componentWidth)
                      )}
                      />
                  )}
                )}
            </div>
          </div>
          <div className={styles.homeBannerTxtWrapperRite}>
            <div className={styles.homeBannerTxtRite}>
              {data.contentCollection &&
                data.contentCollection.items &&
                data.contentCollection.items.map(item => {
                  let headingStyle = '';
                  if (
                    item.styles &&
                    headingStyles[item.styles.trim()] !== undefined
                  ) {
                    headingStyle = headingStyles[item.styles.trim()];
                  }
                  const widthClass = getWidth(item.componentWidth);
                  return (
                    <div>
                      {item.heading && (
                        <Typography
                          key={item.sys.id}
                          className={classNames(
                            widthClass,
                            headingStyle,
                            item.styles
                          )}
                          component={
                            item.headingName
                              ? item.headingName.toLowerCase()
                              : 'div'
                          }
                          dangerouslySetInnerHTML={
                            item.heading && {
                              __html: DOMPurify.sanitize(item.heading),
                            }
                          }
                        />
                      )}
                      {item.body && (
                        <div
                          className={classNames(richTextStyles[item.styles])}
                        >
                          {item.body}
                        </div>
                      )}
                    </div>
                  );
                })}

              {data.linkButton && (
                <Button
                  to={data.linkButton.link}
                  className={classNames(buttonStyles[data.linkButton.styles])}
                  key={data.linkButton.sys.id}
                  title={data.linkButton.tooltip}
                  aria-label={data.linkButton.styles === 'home-card-button-discover' ? 'Experimente a nova coleção Pantene Molecular Bond Repair' : data.linkButton.tooltip}
                  target={data.linkButton.target}
                >
                  {data.linkButton.linkText}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HomeBanner.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]),
};

HomeBanner.defaultProps = {
  data: null,
};
export default HomeBanner;
